import { useRouter } from "next/router";
// import DiscountIcon from "../icons/DiscountIcon";
import Image from "../global/Image";
import { checkOfferAvailability } from "@/helpers/product";
import { v4 as uuidv4 } from "uuid";

const AvailableOffer = ({ freeGifts, cartRule, groupId, t }) => {
  const { locale } = useRouter();
  const gifts = Object.values(freeGifts || {}).flat();

  const { isAvailable, timeRemaining } = checkOfferAvailability(
    cartRule?.at(0)?.from_date,
    cartRule?.at(0)?.to_date
  );
  const validGroupId =
    (groupId == null && cartRule?.at(0)?.customer_group_ids?.includes("0")) ||
    cartRule?.at(0)?.customer_group_ids?.includes(groupId?.toString());

  return (
    isAvailable &&
    validGroupId &&
    gifts?.length > 0 && (
      <div className="border p-3 rounded-md bg-[#F7F5F5]">
        <h5 className="font-bold mb-3 max-sm:text-xs text-[15px]">
          {t("Available offers")}
        </h5>
        {timeRemaining && (
          <p className="my-2 max-sm:text-xs text-[#515EA4]">
            {t("Order within")} {timeRemaining}{" "}
            {t("hours to receive the offer")}
          </p>
        )}
        {gifts?.length > 0 &&
          gifts?.map((gift) => (
            <div
              key={uuidv4()}
              className="flex items-center gap-2 p-2 bg-white rounded-md"
            >
              {/* <DiscountIcon className="text-[#515EA4]" /> */}
              <Image
                src={`${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product${gift?.product_image}`}
                alt=""
                className="text-[#515EA4] w-16"
              />
              <div className="text-[15px] max-sm:text-xs">
                <p className="font-bold text-[#4A63A9]">
                  {locale == "en" ? gift?.product_name : gift?.product_name_ar}{" "}
                </p>
                <p className="text-[#919392]">
                  {t("The product will be added to the cart automatically.")}{" "}
                </p>
              </div>
            </div>
          ))}
      </div>
    )
  );
};

export default AvailableOffer;
